import React, { Component, FunctionComponent, ReactElement } from 'react';

import { SocialNetworksAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { string } from '@philips-emr/tws-core/lib/component/prop-types';

import { ReactComponent as FacebookIcon } from '../../../resources/assets/components/social-networks/facebook.svg';
import { ReactComponent as InstagramIcon } from '../../../resources/assets/components/social-networks/instagram.svg';
import { ReactComponent as LinkedinIcon } from '../../../resources/assets/components/social-networks/linkedin.svg';
import { ReactComponent as TwitterIcon } from '../../../resources/assets/components/social-networks/twitter.svg';
import { ReactComponent as YoutubeIcon } from '../../../resources/assets/components/social-networks/youtube.svg';

import './social-networks.css';

export interface SocialNetworksProps {
  facebook: string;
  instagram: string;
  linkedin: string;
  twitter: string;
  youtube: string;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: SocialNetworksAPI })
class SocialNetworks extends Component<SocialNetworksProps> {

  static propTypes = {
    facebook: string,
    instagram: string,
    linkedin: string,
    twitter: string,
    youtube: string,
  };

  renderIcon(network: string, Icon: FunctionComponent): ReactElement | null {
    if (!network) {
      return null;
    }

    return (
      <a href={network} rel="noopener noreferrer" target="_blank">
        <Icon />
      </a>
    );
  }

  render(): ReactElement {
    const { facebook, instagram, linkedin, twitter, youtube } = this.props;

    return (
      <div className="c-social-networks">
        {this.renderIcon(facebook, FacebookIcon)}
        {this.renderIcon(instagram, InstagramIcon)}
        {this.renderIcon(linkedin, LinkedinIcon)}
        {this.renderIcon(twitter, TwitterIcon)}
        {this.renderIcon(youtube, YoutubeIcon)}
      </div>
    );
  }
}

export default SocialNetworks;
